import { useLiveQuery } from "dexie-react-hooks";
import { db } from "../../schema.dexie";
import { emojiAtividade } from "../emoji";
import type { TipoAtividade } from "../types";

/**
 * Mostra a imagem da atividade. Procura a 1ª mídia que seja IMAGEM (as mídias podem
 * misturar foto e clipe de vídeo do jogo); se não houver, cai num emoji por nome/tipo.
 * Indica 🎬 quando há um clipe de vídeo anexado. Reaproveita as classes .foto do app.
 */
export function AtividadeFoto({
  midias,
  nome,
  tipo,
  className = "",
}: {
  midias?: string[];
  nome?: string | null;
  tipo?: TipoAtividade | null;
  className?: string;
}) {
  const dados = useLiveQuery(async () => {
    let imagem: Blob | undefined;
    let temVideo = false;
    for (const ref of midias ?? []) {
      const f = await db.foto.get(ref);
      if (!f) continue;
      if (!imagem && f.blob.type.startsWith("image")) imagem = f.blob;
      if (f.blob.type.startsWith("video")) temVideo = true;
    }
    return { imagem, temVideo };
  }, [(midias ?? []).join(",")]);

  const blobUrl = dados?.imagem ? URL.createObjectURL(dados.imagem) : null;
  const glifo = emojiAtividade(nome, tipo);

  return (
    <div className={`foto ${className}`} aria-hidden={!blobUrl}>
      {blobUrl ? (
        <img
          src={blobUrl}
          alt=""
          onLoad={() => URL.revokeObjectURL(blobUrl)}
        />
      ) : (
        <span>{glifo}</span>
      )}
      {dados?.temVideo && (
        <span className="foto-audio" aria-hidden>
          🎬
        </span>
      )}
    </div>
  );
}
